import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getStepIndicatorType, StepIndicator } from './StepIndicator/StepIndicator';
import { getStepContentWrapperStyles, getStepContentWrapperVisibilityStyles, getStepperWrapperStyles, getStepTitleStyles, getStepTitleWrapperStyles, stepLoadingAnimationStyles, stepWrapperStyles } from './Stepper.styles';
import { SchedulingStep } from '@src/lib/types';
import { useSchedulingStore } from '@src/store';
type StepperProps = {
  selectedIndex: number;
  onStepTitleClick: (index: number) => void;
  steps: SchedulingStep[];
};
export const Stepper = ({
  steps,
  selectedIndex,
  onStepTitleClick
}: StepperProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    isTimeslotsLoading,
    currentStepIndex
  } = useSchedulingStore(state => state);
  const handleStepTitleClick = (index: number) => {
    if (index < selectedIndex) {
      onStepTitleClick(index);
    }
  };
  return <Box data-test-id="stepper-wrapper" sx={{
    width: '100%'
  }} data-sentry-element="Box" data-sentry-component="Stepper" data-sentry-source-file="Stepper.tsx">
			{steps.map((step, i) => {
      const stepIndicatorType = getStepIndicatorType(selectedIndex, i);
      const isLastStep = i === steps.length - 1;
      const isTimeslotsStep = i === 2;
      const isCurrentStep = i === currentStepIndex;
      return <Box sx={getStepperWrapperStyles(isMobile)} key={i}>
						<StepIndicator stepIndicatorType={stepIndicatorType} isLastStep={isLastStep} dataTestId={generateStepIndicatorTestId(step.title)} />
						<Box sx={stepWrapperStyles}>
							<Box sx={getStepTitleWrapperStyles(isMobile)}>
								<Typography onClick={() => handleStepTitleClick(i)} variant="header4" component="h4" sx={getStepTitleStyles(stepIndicatorType)}>
									{step.title}
								</Typography>
								{isTimeslotsStep && isTimeslotsLoading && <Box sx={stepLoadingAnimationStyles} />}
							</Box>
							<Box sx={getStepContentWrapperVisibilityStyles(isMobile, isCurrentStep)}>
								<Box sx={getStepContentWrapperStyles(stepIndicatorType)}>{step.component}</Box>
							</Box>
						</Box>
					</Box>;
    })}
		</Box>;
};
const generateStepIndicatorTestId = (title: string) => {
  return `step-indicator-${title.toLowerCase().replace(/\s+/g, '-')}`;
};